import { defineEvent } from '../types/event';
export var COUPON_FAB_VIEW = defineEvent({
    platforms: [
        {
            name: 'Optimizely'
        }
    ]
});
